<template>
  <div>
    <div class="w-[50%] <lg:w-full">
      <AddAddress @reload="reload"></AddAddress>
    </div>
    <p class="h-4 bg-mainGray -mx-8 mt-8"></p>
    <div class="text-left">
      <ShowAddress
        :data="addr_data"
        @remove="reload"
        @setDefault="reload"
        @modify="modify"
      ></ShowAddress>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" width="30%">
      <AddAddress
        :addr_message="addr_message"
        :title="title"
        @remodify="remodify"
        v-if="show"
      ></AddAddress>
    </el-dialog>
  </div>
</template>
<script>
import AddAddress from "@/components/mine/addAddress.vue";
import ShowAddress from "@/components/mine/showAddress.vue";
import { onMounted, ref } from "@vue/composition-api";

export default {
  components: { AddAddress, ShowAddress },
  setup(props, ctx) {
    const addr_data = ref();
    const dialogFormVisible = ref(false);
    const reload = async () => {
      const res = await ctx.root.$callapi("user/getAddressList", {
        page: 1,
        size: 50,
      });
      addr_data.value = res.data;
    };
    onMounted(() => {
      reload();
    });

    const show = ref(true);
    const addr_message = ref();
    const title = ref();
    const modify = async (id) => {
      const addr_item = await ctx.root.$callapi("user/getAddress", { aid: id });
      const res = await ctx.root.$callapi("getAddressByLatLng", { 
        longitude: addr_item.data.longitude, 
        latitude: addr_item.data.latitude,
        });  
      addr_message.value = addr_item.data;
      addr_message.value.areanames = res.data.areastext?res.data.areastext:"未知区域";
      show.value = false;
      ctx.root.$nextTick(() => {
        show.value = true;
      });
      dialogFormVisible.value = true;
      title.value = ctx.root.$t("修改");
    };
    const remodify = () => {
      reload();
      dialogFormVisible.value = false;
    };
    return {
      addr_data,
      reload,
      dialogFormVisible,
      modify,
      addr_message,
      show,
      title,
      remodify,
    };
  },
};
</script>
<style scoped lang="scss"></style>
